import { render, staticRenderFns } from "./BTPortalCollapse.vue?vue&type=template&id=2a595f6a&"
import script from "./BTPortalCollapse.vue?vue&type=script&lang=ts&"
export * from "./BTPortalCollapse.vue?vue&type=script&lang=ts&"
import style0 from "./BTPortalCollapse.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports